import { AxiosResponse } from 'axios';
import { pdfApi } from './apis';
import { PDFResponseInterface } from '@types';

export const getPdf = async (data: AxiosResponse['data']): Promise<PDFResponseInterface> => {
  const response = await pdfApi.post('/', data);

  return response.data;
};
